import React from 'react'
import PropTypes from 'prop-types'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import EmailIcon from '../../assets/EmailIcon'
import TextIcon from '../../assets/TextIcon'
import css from './request-review-buttons.css'

const InnerRequestReviewButton = ({
  type,
  appointment,
  disableButton,
  requestReview,
}) => {
  const appointmentReviewed = !!appointment.review
  let disabled = false
  let icon = type === 'text' ?
    <TextIcon /> :
    <EmailIcon />
  if (
    (type === 'text' && appointment.review_requested_by_text) ||
    (type === 'email' && appointment.review_requested_by_email)
  ) {
    disabled = true
    icon = <CheckCircle />
  }
  if (appointmentReviewed) disabled = true

  return (
    <button
      onClick={() => requestReview(type)}
      disabled={disableButton || disabled}
      className={css.button}
    >
      <div>
        {icon}
        <span>{type}</span>
      </div>
    </button>
  )
}

InnerRequestReviewButton.propTypes = {
  type: PropTypes.string.isRequired,
  appointment: PropTypes.shape({
    review: PropTypes.object,
  }),
  disableButton: PropTypes.bool.isRequired,
  requestReview: PropTypes.func.isRequired,
}

export default InnerRequestReviewButton



// WEBPACK FOOTER //
// ./src/components/sitewide/Reviews/InnerRequestReviewButton.js